import React, { useState } from "react";
import {
  ArrowRight,
  CalendarDays,
  CheckCircle2,
  Clock3,
  FileText,
  Gift,
  MapPin,
  Rocket,
  Sparkles,
  Upload,
  Users,
  Wallet,
  Instagram,
  ExternalLink,
  ChevronDown,
  ChevronUp
} from "lucide-react";

import "./AceleracaoNFSB.css";
import PartnersRuler from "../components/PartnersRuler";

const EDITAL_PDF_URL = "/nfsb/edital-nunca-foi-so-batom.pdf";

/*
 * Endpoint utilizado pelo formulário original de inscrições.
 */
const FORM_ENDPOINT = "/api/nfsb/inscricoes";

const APROVADAS = [
  "Aldineidy Da Silva Nascimento",
  "Alice Maria Bezerra da Rocha",
  "Ana Carolina Alexandre Sales",
  "Ana Caroline Gonçalves da Silva",
  "Ana Rosa Garcia Pinto",
  "Anadria Fonseca da Silva",
  "Andressa do Amaral Toratti",
  "Beatriz Mendes Ferreira",
  "CHRÍSNA DA SILVA LIMA OLIVEIRA",
  "CLÁUDIA ELANE DE OLIVEIRA SILVA AMOÊDO",
  "Clenize Queiroz de Vasconcelos",
  "Daniele de Oliveira Melo",
  "Dauzenir Galvão Feijó",
  "Dayane Neres vale",
  "Edclecia da Silva Freitas",
  "Eliana Santos de Sousa Oliveira",
  "Eloilma Chaves Vieira Lima",
  "Emanuelle Fernandes de Souza",
  "Erika Silva Ferreira Santos",
  "Erunayá Sampaio de Moura",
  "Francisca barbosa de lima",
  "Francisca Daiana Silva de Miranda",
  "Francisca Samara Soares Nascimento",
  "Gilda Maria de Morais",
  "Gleiciane Bezerra de Souza",
  "GLEICIANE DA SILVA PINTO",
  "Gleiziane de Carvalho Silva Justo",
  "Iasmin Miranda",
  "Janaína Facco",
  "Janessa do Nascimento Costa",
  "Kamylla oliveira",
  "Karen Christine Ferreira da Silva",
  "Katianny da Silva Araujo",
  "Ligiane Santos Pereira",
  "Lilian Oliveira pinheiro",
  "Livia Chris Freitas de Oliveira",
  "Lizandra Nogueira Royer",
  "Luana Pereira Moura",
  "Luziene de Lima Castro",
  "MARCIANE VILEME DE ARAÚJO",
  "Maria clara cabral dos santos",
  "Maria Eduarda Fernandes Felix",
  "Maria Genacilda da Silva Felix apelido jaqueline",
  "MARIA JAQUELINE DE MIRANDA SOUZA XAVIER",
  "Maria Tomé Tomé",
  "Mayra Wolter de Oliveira Cavalcante",
  "Mellyze Souza de Lima",
  "Michele Souza",
  "Nathânia Oliveira Silva",
  "Nayara de Melo Alves",
  "paola grecia felix mendes",
  "Raquel Moreira Braña",
  "RAYLANE COSTA DE ALMEIDA",
  "RENATA TANAYRA PEREIRA DA SILVA",
  "Sabrina Sondre de Oliveira Reis",
  "Simone Rocha",
  "Simony dos Santos Bertoldo",
  "Suzana de Araújo e Silva",
  "Valéria Oaskes Bastos",
  "Vanderline Silva Bento",
  "Yeza de Paula Menezes Melchior",
  "Ytalla Raquel Vieira da Mota"
];

const AceleracaoNFSB = () => {
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");
  const [openFaq, setOpenFaq] = useState(null);
  const [buscaAprovada, setBuscaAprovada] = useState("");
  const [paginaAprovadas, setPaginaAprovadas] = useState(1);

  const APROVADAS_POR_PAGINA = 10;

  const normalizarTexto = (valor) =>
    valor
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const aprovadasFiltradas = APROVADAS.filter((nome) =>
    normalizarTexto(nome).includes(normalizarTexto(buscaAprovada))
  );

  const totalPaginasAprovadas = Math.max(
    1,
    Math.ceil(aprovadasFiltradas.length / APROVADAS_POR_PAGINA)
  );

  const inicioAprovadas =
    (paginaAprovadas - 1) * APROVADAS_POR_PAGINA;

  const aprovadasPagina = aprovadasFiltradas.slice(
    inicioAprovadas,
    inicioAprovadas + APROVADAS_POR_PAGINA
  );

  const pesquisarAprovada = (event) => {
    setBuscaAprovada(event.target.value);
    setPaginaAprovadas(1);
  };

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;

    try {
      setSending(true);
      setMessage("");

      const rawFormData = new FormData(form);

      const fileFields = [
        "documento_identificacao",
        "comprovante_residencia",
        "comprovante_cnpj",
        "comprovante_negocio"
      ];

      const payload = {};

      for (const [key, value] of rawFormData.entries()) {
        if (fileFields.includes(key)) {
          continue;
        }

        /*
         * Quando existem vários campos com o mesmo nome,
         * como ferramentas_digitais, armazenamos em array.
         */
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          if (!Array.isArray(payload[key])) {
            payload[key] = [payload[key]];
          }

          payload[key].push(value);
        } else {
          payload[key] = value;
        }
      }

      const requestData = new FormData();

      requestData.append(
        "payload",
        JSON.stringify(payload)
      );

      fileFields.forEach((fieldName) => {
        const file = rawFormData.get(fieldName);

        if (
          file &&
          file instanceof File &&
          file.size > 0
        ) {
          requestData.append(
            fieldName,
            file,
            file.name
          );
        }
      });

      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        body: requestData
      });

      let result = {};

      try {
        result = await response.json();
      } catch {
        result = {};
      }

      if (!response.ok) {
        const detail =
          typeof result.detail === "string"
            ? result.detail
            : "Não foi possível enviar a inscrição.";

        throw new Error(detail);
      }

      if (!result.protocolo) {
        throw new Error(
          "A inscrição foi recebida, mas o protocolo não foi retornado."
        );
      }

      setMessage(
        `Inscrição enviada com sucesso! Seu protocolo é ${result.protocolo}. Guarde este número para acompanhamento.`
      );

      form.reset();

      window.setTimeout(() => {
        document
          .getElementById("mensagem-formulario")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
      }, 100);

    } catch (error) {
      console.error("Erro na inscrição NFSB:", error);

      setMessage(
        error?.message ||
        "Não foi possível enviar sua inscrição. Confira os dados e tente novamente."
      );

      window.setTimeout(() => {
        document
          .getElementById("mensagem-formulario")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
      }, 100);

    } finally {
      setSending(false);
    }
  };

  const faqs = [
    {
      pergunta: "Preciso ter CNPJ para participar?",
      resposta:
        "Não. O edital permite a participação de negócios formalizados e informais, desde que o negócio esteja em funcionamento e isso possa ser comprovado."
    },
    {
      pergunta: "Preciso estar em Rio Branco?",
      resposta:
        "Sim. Nesta fase do programa, a candidata deve residir em Rio Branco/AC."
    },
    {
      pergunta: "A participação é gratuita?",
      resposta:
        "Sim. A participação no Programa Nunca Foi Só Batom é gratuita."
    },
    {
      pergunta: "Todas as participantes recebem bolsa?",
      resposta:
        "Não. A Bolsa Sócio-Empreendedora é destinada às 30 participantes selecionadas para a Fase 2, observadas as condições previstas no edital."
    },
    {
      pergunta: "Qual o valor da bolsa?",
      resposta:
        "A bolsa prevista para a Fase 2 é de R$ 1.740,00 por parcela, podendo chegar a duas parcelas e totalizar até R$ 3.480,00 por participante."
    },
    {
      pergunta: "Qual a frequência mínima?",
      resposta:
        "É exigida frequência mínima de 80% nas atividades presenciais obrigatórias, além do cumprimento das demais atividades previstas no edital."
    }
  ];

  return (
    <main className="nfsb-page notranslate" translate="no">
      {/* HERO */}
      <section className="nfsb-hero">
        <div className="nfsb-noise" />

        <div className="nfsb-hero-decoration nfsb-decoration-one">
          ✦
        </div>
        <div className="nfsb-hero-decoration nfsb-decoration-two">
          ↑
        </div>
        <div className="nfsb-hero-decoration nfsb-decoration-three">
          ♥
        </div>

        <div className="nfsb-container nfsb-hero-grid">
          <div className="nfsb-hero-copy">
            <span className="nfsb-kicker">
              EDITAL IMA Nº 01/2026
            </span>

            <h1>
              Nunca Foi Só
              <span>Batom.</span>
            </h1>

            <p className="nfsb-hero-subtitle">
              Aceleração de Negócios Femininos para Inovação
              e Transformação Digital
            </p>

            <p className="nfsb-hero-description">
              Uma jornada prática de formação, mentoria,
              inovação e aceleração criada para mulheres que
              querem fortalecer seus negócios, ampliar suas
              vendas e transformar suas ideias em crescimento.
            </p>

            <div className="nfsb-hero-actions">
              <a
                href="#inscricao"
                className="nfsb-btn nfsb-btn-primary"
              >
                Quero me inscrever
                <ArrowRight size={19} />
              </a>

              <a
                href={EDITAL_PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="nfsb-btn nfsb-btn-outline"
              >
                <FileText size={19} />
                Ler edital completo
              </a>
            </div>

            <div className="nfsb-hero-deadline">
              <CalendarDays size={20} />
              <div>
                <strong>Inscrições abertas</strong>
                <span>14 a 27 de setembro de 2026</span>
              </div>
            </div>
          </div>

          <div className="nfsb-hero-art">
            <div className="nfsb-art-circle">
              <div className="nfsb-lipstick">
                <div className="nfsb-lipstick-tip" />
                <div className="nfsb-lipstick-middle" />
                <div className="nfsb-lipstick-base" />
              </div>

              <span className="nfsb-art-text nfsb-art-text-1">
                NEGÓCIO
              </span>
              <span className="nfsb-art-text nfsb-art-text-2">
                TAMBÉM!
              </span>
            </div>

            <div className="nfsb-sticker nfsb-sticker-yellow">
              <Sparkles size={21} />
              atitude gera oportunidades
            </div>

            <div className="nfsb-sticker nfsb-sticker-white">
              mulheres apoiam mulheres
            </div>
          </div>
        </div>
      </section>

      {/* RESUMO */}
      <section className="nfsb-quick">
        <div className="nfsb-container">
          <div className="nfsb-quick-grid">
            <div className="nfsb-quick-card">
              <Users />
              <strong>60</strong>
              <span>empreendedoras na Fase 1</span>
            </div>

            <div className="nfsb-quick-card">
              <Rocket />
              <strong>30</strong>
              <span>negócios avançam para a Fase 2</span>
            </div>

            <div className="nfsb-quick-card">
              <Clock3 />
              <strong>55h</strong>
              <span>de jornada formativa</span>
            </div>

            <div className="nfsb-quick-card">
              <Wallet />
              <strong>R$ 3.480</strong>
              <span>bolsa máxima na Fase 2</span>
            </div>
          </div>
        </div>
      </section>

      {/* SOBRE */}
      <section className="nfsb-section nfsb-section-light">
        <div className="nfsb-container nfsb-two-columns">
          <div>
            <span className="nfsb-section-kicker">
              SOBRE O PROGRAMA
            </span>

            <h2>
              Seu negócio já existe.
              <span> Agora é hora de fazê-lo crescer.</span>
            </h2>
          </div>

          <div className="nfsb-large-copy">
            <p>
              O <strong>Nunca Foi Só Batom</strong> é uma
              iniciativa de formação, mentoria e aceleração para
              mulheres que já desenvolvem atividades econômicas
              e querem fortalecer seus empreendimentos por meio
              da inovação, melhoria da proposta de valor,
              transformação digital, gestão e novos canais de
              comercialização.
            </p>

            <p>
              Aqui, inovação não significa apenas tecnologia
              avançada. Também pode estar na melhoria do seu
              produto, no atendimento, na embalagem, na marca,
              nos processos, no uso das redes sociais ou em uma
              nova forma de vender.
            </p>
          </div>
        </div>
      </section>

      {/* QUEM PODE */}
      <section className="nfsb-section nfsb-section-black">
        <div className="nfsb-container">
          <span className="nfsb-section-kicker pink">
            CONFIRA OS REQUISITOS
          </span>

          <div className="nfsb-title-row">
            <h2>Quem pode participar?</h2>
            <div className="nfsb-badge-big">
              RIO BRANCO
              <span>/ AC</span>
            </div>
          </div>

          <div className="nfsb-requirements-grid">
            {[
              "Mulheres com 18 anos ou mais",
              "Residentes em Rio Branco/AC",
              "Proprietárias, titulares ou sócias do negócio",
              "Negócio formalizado ou informal em funcionamento",
              "Disponibilidade para encontros presenciais e mentorias",
              "Compromisso com a elaboração e execução do PATIN"
            ].map((item) => (
              <div className="nfsb-requirement" key={item}>
                <CheckCircle2 />
                <span>{item}</span>
              </div>
            ))}
          </div>

          <div className="nfsb-attention">
            <strong>Não é necessário ter CNPJ.</strong>
            <p>
              Negócios informais também podem participar. Será
              necessário comprovar que a atividade econômica já
              está em funcionamento.
            </p>
          </div>
        </div>
      </section>

      {/* SEGMENTOS */}
      <section className="nfsb-section nfsb-section-cream">
        <div className="nfsb-container">
          <div className="nfsb-center-title">
            <span className="nfsb-section-kicker">
              TODA MULHER EMPREENDEDORA PODE INOVAR
            </span>
            <h2>Negócios de diferentes segmentos são bem-vindos</h2>
          </div>

          <div className="nfsb-tags">
            {[
              "Alimentação",
              "Artesanato",
              "Beleza e estética",
              "Comércio",
              "Comunicação",
              "Cultura",
              "Educação",
              "Eventos",
              "Moda",
              "Saúde e bem-estar",
              "Tecnologia",
              "Turismo",
              "Serviços",
              "Agricultura",
              "Agroindústria",
              "Bioeconomia",
              "Economia criativa",
              "Produtos amazônicos"
            ].map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </div>
      </section>

      {/* FASES */}
      <section className="nfsb-section nfsb-section-white">
        <div className="nfsb-container">
          <span className="nfsb-section-kicker">
            COMO FUNCIONA
          </span>

          <h2 className="nfsb-section-title">
            Uma jornada em duas fases
          </h2>

          <div className="nfsb-phases">
            <div className="nfsb-phase nfsb-phase-pink">
              <span className="nfsb-phase-number">01</span>
              <div>
                <span className="nfsb-phase-label">
                  60 PARTICIPANTES
                </span>
                <h3>Diagnóstico e construção do PATIN</h3>

                <ul>
                  <li>Inovação para negócios tradicionais</li>
                  <li>Modelo de negócio e proposta de valor</li>
                  <li>Produto, serviço e posicionamento</li>
                  <li>Construção e fortalecimento de marca</li>
                </ul>
              </div>
            </div>

            <div className="nfsb-phase nfsb-phase-black">
              <span className="nfsb-phase-number">02</span>
              <div>
                <span className="nfsb-phase-label">
                  30 PARTICIPANTES
                </span>
                <h3>Aceleração do negócio</h3>

                <ul>
                  <li>Conteúdo, fotografia e vitrine digital</li>
                  <li>Digitalização e inteligência artificial</li>
                  <li>WhatsApp Business, redes sociais e vendas</li>
                  <li>
                    Gestão financeira e indicadores de crescimento
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BOLSA */}
      <section className="nfsb-scholarship">
        <div className="nfsb-container nfsb-scholarship-grid">
          <div>
            <span className="nfsb-section-kicker yellow">
              BOLSA SÓCIO-EMPREENDEDORA
            </span>

            <h2>
              Até
              <strong>R$ 3.480,00</strong>
              para participantes da Fase 2
            </h2>

            <p>
              As 30 empreendedoras selecionadas para a Fase 2
              poderão receber até duas parcelas de R$ 1.740,00,
              conforme as condições do edital.
            </p>
          </div>

          <div className="nfsb-scholarship-card">
            <Gift size={38} />

            <h3>Para continuar transformando o seu negócio</h3>

            <p>
              O incentivo busca apoiar a implementação prática de
              ações de inovação e transformação digital previstas
              no plano de aceleração.
            </p>

            <div className="nfsb-mini-rule">
              <CheckCircle2 />
              frequência mínima de 80%
            </div>

            <div className="nfsb-mini-rule">
              <CheckCircle2 />
              realização das atividades propostas
            </div>

            <div className="nfsb-mini-rule">
              <CheckCircle2 />
              participação nas mentorias
            </div>

            <div className="nfsb-mini-rule">
              <CheckCircle2 />
              desenvolvimento do PATIN
            </div>
          </div>
        </div>
      </section>

      {/* CRONOGRAMA */}
      <section className="nfsb-section nfsb-section-light">
        <div className="nfsb-container">
          <span className="nfsb-section-kicker">
            DATAS IMPORTANTES
          </span>

          <h2 className="nfsb-section-title">
            Cronograma
          </h2>

          <div className="nfsb-timeline">
            {[
              ["14/09", "Abertura das inscrições"],
              ["27/09", "Último dia para inscrição"],
              [
                "28/09 — 01/10",
                "Análise documental e avaliação de mérito"
              ],
              ["02/10", "Resultado preliminar"],
              ["05 e 06/10", "Recursos administrativos"],
              ["07 e 08/10", "Resultado final e homologação"],
              ["09/10", "Aula inaugural"],
              ["09/10 — 30/10", "Fase 1"],
              ["03 — 05/11", "Avaliação para a Fase 2"],
              ["06/11", "Resultado da Fase 2"],
              ["09/11 — 11/12", "Fase 2 – Aceleração"],
              ["15/12", "Encerramento e certificados"]
            ].map(([date, title], index) => (
              <div className="nfsb-timeline-item" key={`${date}-${title}`}>
                <div className="nfsb-timeline-index">
                  {String(index + 1).padStart(2, "0")}
                </div>

                <strong>{date}</strong>
                <span>{title}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CRITÉRIOS */}
      <section className="nfsb-section nfsb-section-black">
        <div className="nfsb-container">
          <span className="nfsb-section-kicker pink">
            PROCESSO SELETIVO
          </span>

          <h2 className="nfsb-section-title">
            O que será avaliado na sua inscrição?
          </h2>

          <div className="nfsb-criteria-grid">
            {[
              [
                "01",
                "História e existência do negócio",
                "20 pontos"
              ],
              [
                "02",
                "Capricho e cuidado com o produto ou serviço",
                "20 pontos"
              ],
              ["03", "Clareza do negócio", "20 pontos"],
              ["04", "Potencial de inovação", "20 pontos"],
              ["05", "Potencial de escalabilidade", "20 pontos"]
            ].map(([number, title, points]) => (
              <div className="nfsb-criteria-card" key={number}>
                <span>{number}</span>
                <h3>{title}</h3>
                <strong>{points}</strong>
              </div>
            ))}
          </div>

          <div className="nfsb-score-note">
            <strong>100 pontos possíveis</strong>
            <span>
              Nota mínima para classificação: 60 pontos
            </span>
          </div>
        </div>
      </section>

      {/* DOCUMENTOS */}
      <section className="nfsb-section nfsb-section-white">
        <div className="nfsb-container nfsb-documents-layout">
          <div>
            <span className="nfsb-section-kicker">
              PREPARE-SE PARA A INSCRIÇÃO
            </span>

            <h2>Separe seus documentos</h2>

            <p>
              Antes de iniciar o formulário, deixe os arquivos
              necessários preparados.
            </p>
          </div>

          <div className="nfsb-document-list">
            {[
              "Documento oficial de identificação com foto",
              "CPF, caso não esteja no documento de identificação",
              "Comprovante de residência em Rio Branco/AC",
              "Comprovante do negócio em funcionamento",
              "CNPJ ou CCMEI, caso o negócio seja formalizado",
              "Para negócio informal: fotos, redes sociais, cartão de visitas, comprovantes de feiras ou outros registros"
            ].map((document) => (
              <div key={document}>
                <FileText />
                <span>{document}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EDITAL */}
      <section className="nfsb-edital-banner">
        <div className="nfsb-container">
          <div>
            <span>ANTES DE SE INSCREVER</span>
            <h2>Leia o edital completo</h2>
            <p>
              Confira todas as regras, requisitos, critérios de
              avaliação, cronograma e condições de participação.
            </p>
          </div>

          <a
            href={EDITAL_PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nfsb-btn nfsb-btn-black"
          >
            <FileText size={20} />
            Acessar edital em PDF
            <ExternalLink size={17} />
          </a>
        </div>
      </section>

      {/* LISTA DE APROVADAS */}
      <section
        id="inscricao"
        className="nfsb-section nfsb-form-section"
      >
        <div className="nfsb-container">

          <div className="nfsb-form-heading nfsb-approved-heading">

            <span className="nfsb-section-kicker">
              RESULTADO
            </span>

            <h2>
              Lista de aprovadas
            </h2>

            <p>
              Confira abaixo as candidatas aprovadas para o programa
              <strong> Nunca Foi Só Batom</strong>.
            </p>

          </div>

          <div className="nfsb-approved-panel">

            <div className="nfsb-approved-search">

              <label htmlFor="busca-aprovada">
                Pesquise seu nome
              </label>

              <div className="nfsb-approved-search-box">

                <span aria-hidden="true">
                  ⌕
                </span>

                <input
                  id="busca-aprovada"
                  type="search"
                  value={buscaAprovada}
                  onChange={pesquisarAprovada}
                  placeholder="Digite seu nome..."
                  autoComplete="off"
                />

              </div>

            </div>

            <div className="nfsb-approved-summary">

              <strong>
                {aprovadasFiltradas.length}
              </strong>{" "}

              {aprovadasFiltradas.length === 1
                ? "aprovada encontrada"
                : "aprovadas encontradas"}

            </div>

            {aprovadasPagina.length > 0 ? (
              <>

                <div className="nfsb-approved-list">

                  {aprovadasPagina.map((nome, index) => (

                    <div
                      className="nfsb-approved-item"
                      key={nome}
                    >

                      <span className="nfsb-approved-number">
                        {String(
                          inicioAprovadas + index + 1
                        ).padStart(2, "0")}
                      </span>

                      <span className="nfsb-approved-name">
                        {nome}
                      </span>

                      <CheckCircle2
                        className="nfsb-approved-check"
                        size={22}
                        aria-hidden="true"
                      />

                    </div>

                  ))}

                </div>

                {totalPaginasAprovadas > 1 && (

                  <div className="nfsb-approved-pagination">

                    <button
                      type="button"
                      onClick={() =>
                        setPaginaAprovadas((pagina) =>
                          Math.max(1, pagina - 1)
                        )
                      }
                      disabled={paginaAprovadas === 1}
                    >
                      Anterior
                    </button>

                    <div className="nfsb-approved-pages">

                      {Array.from(
                        { length: totalPaginasAprovadas },
                        (_, index) => index + 1
                      ).map((pagina) => (

                        <button
                          type="button"
                          key={pagina}
                          className={
                            paginaAprovadas === pagina
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            setPaginaAprovadas(pagina)
                          }
                          aria-current={
                            paginaAprovadas === pagina
                              ? "page"
                              : undefined
                          }
                        >
                          {pagina}
                        </button>

                      ))}

                    </div>

                    <button
                      type="button"
                      onClick={() =>
                        setPaginaAprovadas((pagina) =>
                          Math.min(
                            totalPaginasAprovadas,
                            pagina + 1
                          )
                        )
                      }
                      disabled={
                        paginaAprovadas ===
                        totalPaginasAprovadas
                      }
                    >
                      Próxima
                    </button>

                  </div>

                )}

              </>
            ) : (

              <div className="nfsb-approved-empty">

                <strong>
                  Nenhum nome encontrado.
                </strong>

                <p>
                  Confira a escrita e tente novamente.
                </p>

              </div>

            )}

          </div>

        </div>
      </section>

      {/* FAQ */}
      <section className="nfsb-section nfsb-section-cream">
        <div className="nfsb-container nfsb-faq-layout">
          <div>
            <span className="nfsb-section-kicker">
              DÚVIDAS FREQUENTES
            </span>
            <h2>Ainda ficou com alguma dúvida?</h2>
          </div>

          <div className="nfsb-faq">
            {faqs.map((faq, index) => (
              <button
                type="button"
                key={faq.pergunta}
                className={`nfsb-faq-item ${
                  openFaq === index ? "open" : ""
                }`}
                onClick={() => toggleFaq(index)}
              >
                <div>
                  <strong>{faq.pergunta}</strong>
                  {openFaq === index ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </div>

                {openFaq === index && <p>{faq.resposta}</p>}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="nfsb-final">
        <div className="nfsb-container">
          <Sparkles />

          <span>NUNCA FOI SÓ BATOM</span>

          <h2>
            É negócio.
            <br />
            É atitude.
            <br />
            <strong>É transformação.</strong>
          </h2>

          <a
            href={EDITAL_PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nfsb-btn nfsb-btn-white"
          >
            Acessar edital
            <ExternalLink size={17} />
          </a>

          <div className="nfsb-final-meta">
            <div>
              <MapPin size={18} />
              Rio Branco · Acre
            </div>

            <div>
              <CalendarDays size={18} />
              Programa Nunca Foi Só Batom
            </div>
          </div>
        </div>
      </section>
          <PartnersRuler />
    </main>
  );
};

export default AceleracaoNFSB;
